
import {interceptorsAxios} from '@/middlewares'
import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Env from '@/components/debug/Env.vue'

const authModule = namespace('auth')

@Component({
  components: {
    Env
  }
})
export default class App extends Vue {
  @authModule.Getter('meGetter') me: any
  @authModule.Getter('tokenGetter') token: any
  @authModule.Action('meAction') getMe: any
  get layout() {
    return (this.$route.meta.layout || 'default') + '-layout'
  }

  @Watch('token')
  watchToken(val: any) {
    if (val && !this.me) this.getMe()
  }

  created() {
    console.log('***** app created ******')
    interceptorsAxios()
    // getMe on rehydrate
    if (!this.me && this.token) this.getMe()
  }
}
